import React from "react";
import { useTranslation } from "react-i18next";
import CallToBook from "Components/CallToBook/CallToBook";
import "./InformationBookSide.css";

const InformationBookSide = ({ tour }) => {
  const { t } = useTranslation("common");

  if (!tour) {
    return <div>{t("loading")}</div>;
  }

  return (
    <div className="informationBookSide">
      <CallToBook tour={tour} isSimple={true} />
    </div>
  );
};

export default InformationBookSide;
